import { Livewire, Alpine } from '../../../../../../../../vendor/livewire/livewire/dist/livewire.esm';
import Clipboard from '@ryangjchandler/alpine-clipboard'

Alpine.plugin(Clipboard)
Livewire.start()

// Swiper
import Swiper from 'swiper';
import { Navigation, Pagination, Grid, Autoplay, Thumbs, Controller, EffectCoverflow } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';
import 'swiper/css/grid';
import 'swiper/css/autoplay';
import 'swiper/css/thumbs';

// Initialize Swiper modules
Swiper.use([Navigation, Pagination, Grid, Autoplay, Thumbs, Controller, EffectCoverflow]);

// Export for global use if needed
window.Swiper = Swiper

// Swal
import Swal from 'sweetalert2';
window.Swal = Swal;
window.Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: 3330,
    timerProgressBar: true
});

// Plyr
import Plyr from 'plyr';
import 'plyr/dist/plyr.css';

// Lazyload
import lazySizes from 'lazysizes';

// fslightbox
import FsLightbox from "fslightbox";

// Fancybox
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
const setupApp = ()=>
{
    lazySizes.init();
    refreshFsLightbox();

    // Fancybox
    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    });

    const myVideoPlayer1 = new Plyr('#myVideoPlayer1', {
        ratio: '343:402',
        clickToPlay: true,
        controls: ['fullscreen'],
    });

    let playBtn= document.getElementById('playBtn')
    if( playBtn )
    {
        playBtn.addEventListener('click', (event) => {
            myVideoPlayer1.togglePlay();
        });
    }

    let heroSwiper = new Swiper("#heroSwiper", {
        modules: [Controller, Pagination, Autoplay],
        slidesPerView: 1,
        spaceBetween: 10,
        // loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
            pauseOnMouseEnter: true,
        },
        pagination: {
            el: "#heroSwiperPagination",
            clickable: true
        },
    });

    let heroSwiper2 = new Swiper("#heroSwiper2", {
        modules: [Controller, Navigation],
        slidesPerView: 1,
        // loop: true,
        navigation: {
            nextEl: "#heroSwiperNext",
            prevEl: "#heroSwiperPrev",
        },
    });

    heroSwiper.controller.control = heroSwiper2;
    heroSwiper2.controller.control = heroSwiper;


    let brandSwiper = new Swiper("#brandSwiper", {
        modules: [Autoplay],
        slidesPerView: 2,
        spaceBetween: 10,
        loop: true,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        speed: 2000,
        breakpoints: {
            480: {
                slidesPerView: 2.5,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 4,
            },
            1280: {
                slidesPerView: 5,
            },
        },
    });


    let shopSwiper = new Swiper("#shopSwiper", {
        loop: true,
        slidesPerView: 1.5,
        spaceBetween: 12,
        breakpoints: {
            480: {
                slidesPerView: 1.3,
            },
            768: {
                slidesPerView: 2.5,
            },
            1024: {
                slidesPerView: 3.8,
            },
            1280: {
                slidesPerView: 4.2,
            },
        },
    });

    let specialProductSwiper = new Swiper("#specialProductSwiper", {
        modules: [Grid],
        slidesPerView: 1.3,
        grid: {
            rows: 3,
            fill: 'row'
        },
        loop: false,
        spaceBetween: 14,
        breakpoints: {
            480: {
                slidesPerView: 1.3,
            },
            768: {
                slidesPerView: 2.5,
            },
            1024: {
                slidesPerView: 2.3,
                grid: {
                    rows: 3,
                    fill: 'row'
                },
            },
            1280: {
                slidesPerView: 3,
                grid: {
                    rows: 3,
                    fill: 'row'
                },
                enabled: false,
                centeredSlides: false,
                centeredSlidesBounds: false
            },
        },
    });

    let portfolioSwiper = new Swiper("#portfolioSwiper", {
        modules: [EffectCoverflow],
        effect: "coverflow",
        loop: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        slidesPerView: 2,
        coverflowEffect: {
            rotate: 20,
            stretch: 0,
            depth: 150,
            modifier: 1,
            slideShadows: false,
        },
        breakpoints: {
            480: {
                slidesPerView: 2.8,
            },
            768: {
                slidesPerView: 3.5,
            },
            1024: {
                slidesPerView: 3.5,
            },
            1280: {
                slidesPerView: 4,
            },
        },
    });

    const portfolioGalleryThumb = new Swiper('.portfolio-thumb-imgs-swiper-container', {
        modules: [Navigation],
        direction: 'horizontal',
        spaceBetween: 10,
        slidesPerView: 5.5,
        centeredSlides:true,
        centeredSlidesBounds:true,
        freeMode: true,
        loop: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        breakpoints: {
            320: {
                slidesPerView: 3.5,
            },
            480: {
                slidesPerView: 3.5,
            },
            640: {
                slidesPerView: 4.5,
            },
            1280:{
                slidesPerView: 5.5,
            },
        }
        // thumbs: {
        //   swiper: productGalleryThumb
        // }
    });

    const portfolioGallery = new Swiper('.portfolio-imgs-swiper-container', {
        modules: [Navigation, Thumbs],
        direction: 'horizontal',
        centeredSlides:true,
        centeredSlidesBounds:true,
        slidesPerView:1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        // clickable:"true",
        spaceBetween: 10,

        thumbs: {
            swiper : portfolioGalleryThumb
        },
    });

    let specialProductSwiper2 = new Swiper("#specialProductSwiper2", {
        slidesPerView: 1.3,
        loop: true,
        spaceBetween: 5,
        breakpoints: {
            480: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 2.3,
            },
            1024: {
                slidesPerView: 3.8,
            },
            1280: {
                slidesPerView: 4.2,
            },
        },
    });

    let blogSwiper = new Swiper("#blogSwiper", {
        modules: [Navigation],
        loop: true,
        slidesPerView: 1,
        navigation: {
            nextEl: "#blogSwiperNext",
            prevEl: "#blogSwiperPrev",
        },
    });




    let instagramSwiper = new Swiper("#instagramSwiper", {
        slidesPerView: 2.3,
        spaceBetween:0,
        breakpoints: {
            480: {
                slidesPerView: 3.5,
            },
            768: {
                slidesPerView: 5,
            },
            1024: {
                slidesPerView: 6,
            },
            1280: {
                slidesPerView: 7,
            },
        },
    });

    let productGalleryThumb = new Swiper('.product-thumb-imgs-swiper-container', {
        modules: [Navigation],
        direction: 'horizontal',
        spaceBetween: 10,
        slidesPerView: 3,
        breakpoints: {
            768:{
                slidesPerView: 4,
            },
        },
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    });

    let productGallery = new Swiper('.product-imgs-swiper-container', {
        modules: [Navigation, Thumbs],
        direction: 'horizontal',
        centeredSlides:true,
        centeredSlidesBounds:true,
        slidesPerView:1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        spaceBetween: 10,
        thumbs: {
            swiper : productGalleryThumb
        },
    });

    let productRelatedItems = new Swiper('.product-related-items',  {
        slidesPerView: 1.2,
        spaceBetween: 15,
        breakpoints:{
            768:{
                slidesPerView: 2.3,
            },
            1024: {
                slidesPerView:3.3,
            },
            1280:{
                slidesPerView:4.3,
            },
        }
    });


    const element = document.querySelector('.navBar');

    window.addEventListener('scroll', () => {
        if (window.scrollY > 0) {
            element.classList.replace('beforScroll', 'afterScroll');
        } else {
            element.classList.replace('afterScroll', 'beforScroll');
        }
    });

};

["livewire:initialized", "livewire:navigated", "resize", "pageChanged"].forEach((event) => {
    window.addEventListener(event, setupApp)
})



